import React from 'react';

function Sort({ sort, setSort }) {
  return (
    <form onSubmit={(e) => e.preventDefault()} className='radio-container'>
      <div>
        <input
          type='radio'
          id='sort'
          name='sort'
          value='published_at_desc'
          checked={sort === 'published_at_desc' || 'latest'}
          onChange={(e) => {
            setSort(e.target.value);
          }}
        />
        <label>Newest First</label>
      </div>

      <div>
        <input
          type='radio'
          id='sort'
          name='sort'
          value='published_at_asc'
          checked={sort === 'published_at_asc'}
          onChange={(e) => {
            setSort(e.target.value);
          }}
        />
        <label>Oldest First</label>
      </div>
    </form>
  );
}

export default Sort;
